import React, { FC, useRef, useState } from 'react';

//devextreem
import Form, { Item, RequiredRule } from 'devextreme-react/form';
import { Popup } from 'devextreme-react/popup';
import ValidationGroup from 'devextreme-react/validation-group';
import Validator from 'devextreme-react/validator';

import { AppGroup, AppRow } from 'components/appComponents';
import AppFiledBox from 'components/appComponents/app-field-box';
import ModalFooter from 'components/appModalFooter';
import { MONEY_FORMAT } from 'constants/formats';
import { NumberBox, TextArea, TextBox } from 'devextreme-react';
import { isSuccess } from 'utils/responseStatus';

import {
  useCreateDriverMixerAdjustmentsDetailMutation,
  useEditDriverMixerAdjustmentsDetailMutation,
  useLazyGetDriverMixerAdjustmentsDetailOneQuery,
} from 'bus/driverMixerAdjustments/servisec';
import { DriverMixerAdjustmentsDetail } from 'bus/driverMixerAdjustments/types';

type CreateEditModalProps = {
  visible: boolean;
  changeVisible: (visible: boolean) => void;
  refresh: () => void;
  adjustmentId: number | null;
  id: number | null;
};

const initialForm: DriverMixerAdjustmentsDetail = {
  id: null,
  description: '',
  sum: 0,
  comment: '',
};

const CreateEditModal: FC<CreateEditModalProps> = ({ changeVisible, refresh, visible, adjustmentId, id }) => {
  let createGroupValidationRef = useRef<ValidationGroup>(null);

  const [form, setForm] = useState<DriverMixerAdjustmentsDetail>(initialForm);
  const [loading, setLoading] = useState(false);

  const [getDetail] = useLazyGetDriverMixerAdjustmentsDetailOneQuery();
  const [createDetail] = useCreateDriverMixerAdjustmentsDetailMutation();
  const [editDetail] = useEditDriverMixerAdjustmentsDetailMutation();

  const onShown = async () => {
    if (id) {
      await getDetail({ id }).then((result) => {
        if (isSuccess(result)) {
          result.data && setForm(result.data);
        }
      });
    } else {
      setForm(initialForm);
    }
  };

  const onHidden = () => {
    setForm(initialForm);
    createGroupValidationRef.current?.instance.reset();
  };

  const handleSubmit = async (e: any) => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 1000);
    e.preventDefault && e.preventDefault();

    if (createGroupValidationRef.current?.instance.validate().isValid) {
      const tempForm = {
        ...form,
        adjustmentId,
      };
      if (id) {
        await editDetail(tempForm);
      } else {
        let temp = { ...tempForm };
        delete temp.id;
        await createDetail({ ...temp });
      }
      changeVisible(false);
      refresh();
    }
  };

  return (
    <div>
      <Popup
        visible={visible}
        onHiding={() => changeVisible(false)}
        dragEnabled={true}
        closeOnOutsideClick={false}
        showTitle={true}
        title="Описание"
        width={500}
        onShowing={onShown}
        onHidden={onHidden}
        height="auto"
      >
        <div className="modal-block">
          <div className="modal-block__content">
            <form onSubmit={handleSubmit}>
              <ValidationGroup ref={createGroupValidationRef}>
                <Form id="test-facrory" formData={form}>
                  <Item colSpan={12} colCount={12} itemType="group">
                    <AppRow>
                      <AppGroup col={12}>
                        <AppFiledBox label="Описание" labelTop>
                          <TextBox
                            stylingMode="underlined"
                            mode="text"
                            value={form.description}
                            onValueChange={(e: any) => {
                              setForm((prev) => ({ ...prev, description: e }));
                            }}
                          >
                            <Validator>
                              <RequiredRule message="Заполните поле Описание" />
                            </Validator>
                          </TextBox>
                        </AppFiledBox>
                      </AppGroup>
                      <AppGroup col={12}>
                        <AppFiledBox label="Сумма" labelTop>
                          <NumberBox
                            stylingMode="underlined"
                            placeholder="0"
                            format={MONEY_FORMAT}
                            value={form.sum}
                            onValueChanged={(e) => {
                              setForm((prev) => ({ ...prev, sum: e.value }));
                            }}
                          >
                            <Validator>
                              <RequiredRule message="Заполните поле Стоимость" />
                            </Validator>
                          </NumberBox>
                        </AppFiledBox>
                      </AppGroup>
                      <AppGroup col={12}>
                        <AppFiledBox label="Комментарий" labelTop>
                          <TextArea
                            stylingMode="underlined"
                            placeholder="Введите комментарий"
                            mode="text"
                            value={form.comment || ''}
                            onChange={(e: any) => {
                              setForm((prev) => ({ ...prev, comment: e.event.currentTarget.value }));
                            }}
                          />
                        </AppFiledBox>
                      </AppGroup>
                    </AppRow>
                  </Item>
                </Form>
                <ModalFooter
                  useSubmitBehavior={false}
                  handleSubmit={handleSubmit}
                  hideModal={() => changeVisible(false)}
                  disabledSubmit={loading}
                />
              </ValidationGroup>
            </form>
          </div>
        </div>
      </Popup>
    </div>
  );
};

export default CreateEditModal;
